import { render, staticRenderFns } from "./BlockedDateDescription.vue?vue&type=template&id=deb785b6&"
import script from "./BlockedDateDescription.vue?vue&type=script&lang=ts&"
export * from "./BlockedDateDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports